module.exports = __webpack_public_path__ + "static/img/product_banner_02_zh.a3ca64f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_banner_02_zh.png
// module id = o17a
// module chunks = 34